import { ListViewModel, ListViewModelImpl } from '../../horizontallist/listviewmodel';
import { BaseContext } from '../../../../utils/basecontext';
import { PaginationComponentState } from '../../pagination/paginationcomponent';

export interface PaginationListViewModel<T> extends ListViewModel<T>
{
    getTotalCount(): number;
    getOffset(): number;
    resetPaginationState(): void;
    getPaginationState(): PaginationComponentState;
}

export class PaginationListViewModelImpl<T> extends ListViewModelImpl<T> implements PaginationListViewModel<T>
{
    private totalCount: number = 0;
    private offset: number = 0;
    private paginationComponentState: PaginationComponentState;

    constructor(offset: number, context: BaseContext)
    {
        super(context);

        this.setOffSet(offset);

       this.resetPaginationState();
    }

    setPaginationState(paginationComponentState: PaginationComponentState)
    {
        this.paginationComponentState = paginationComponentState;
    }

    getPaginationState(): PaginationComponentState
    {
        return this.paginationComponentState;
    }

    setOffSet(offset: number)
    {
        this.offset = offset;
    }

    setTotalCount(totalCount: number)
    {
        this.totalCount = totalCount;
    }

    getTotalCount(): number 
    {
        return this.totalCount;
    }

    resetPaginationState()
    {
        console.log("-----length: " + this.getListOfDatas().length);
        this.paginationComponentState = {currentPageNo: 1, startIndex: 0, isLeftArrowEnabled: false, 
            isRightArrowEnabled: this.getListOfDatas().length >= this.getOffset() ? true : false, arrowSelected: "right"};
    }

    getOffset(): number {
       return this.offset;
    }
}



// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/ui/toolkit/verticallist/paginationverticallist/paginationlistviewmodel.ts